// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__4v5ZA","header":"ReportDetails_header__1ILr9","title":"ReportDetails_title__2M9CT","left":"ReportDetails_left__1C1Si"};